import { InjectionToken, Provider } from '@angular/core';

export const ISS_SUPPORT_LINK = new InjectionToken<string>('ISS_SUPPORT_LINK');

export const provideIssSupportLink = (useValue: string): Provider => ({
  provide: ISS_SUPPORT_LINK,
  useValue,
});
